export default "__VITE_PUBLIC_ASSET__da70db15__"